import React from 'react'
import { editSequenceBulk } from '../gql'
import { useDispatch } from 'react-redux'
import { Box } from '@material-ui/core'
import {
  hideReduxModal,
  resetReduxModal,
  showReduxModal,
} from '../../../../../../Reducers/UI/actions'

export const useBulkArchiveSequence = ({ getSequenceById, onFinish }) => {
  const dispatch = useDispatch()

  const handleBulkArchive = async sequenceIds => {
    const sequences = sequenceIds.map(id => ({ id, status: 'ARCHIVED' }))

    let message = {
      title: 'Success',
      text: 'The selected sequences have been archived.',
    }

    try {
      const responce = await editSequenceBulk({ sequences })
      const result = await responce.json()
      const data = JSON.parse(result.data.bulkUpdateSequences)

      if (data.failedUpdate) {
        const failedSequenceData = getSequenceById(data.failedUpdate.id)
        message = {
          title: 'Something went wrong',
          text: `The sequence ${
            failedSequenceData.name
          } was failed to archive with error "${
            data.failedUpdate.error
          }". Next updates was cancelled`,
        }
      }
    } catch (error) {
      message = {
        title: 'Failure',
        text: 'Error happened on archiving sequence',
      }
    }

    dispatch(
      showReduxModal({
        title: message.title,
        children: (
          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
            mt={3}
            mb={3}
          >
            <p>
              {message.text}
              <br />
            </p>
          </Box>
        ),
        onConfirm: async () => {
          hideReduxModal()
          resetReduxModal()
          onFinish(sequenceIds.length)
        },
        hideCancel: true,
        aspect: 'nonScrollable',
      }),
    )
  }

  const onBulkArchiveSequences = selectedSeqs => async () => {
    dispatch(
      showReduxModal({
        title: 'Confirm Bulk Archive',
        children: (
          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
            mt={3}
            mb={3}
          >
            <p>
              Are you sure you want to archive the selected sequences?
              <br />
            </p>
          </Box>
        ),
        onConfirm: async () => {
          try {
            handleBulkArchive(selectedSeqs)
            hideReduxModal()
            resetReduxModal()
          } catch (error) {
            hideReduxModal()
            resetReduxModal()
            alert(`Error occurred: ${error.message}`)
          }
        },
        onCancel: () => {
          hideReduxModal()
          resetReduxModal()
        },
        aspect: 'nonScrollable',
      }),
    )
  }

  return { onBulkArchiveSequences }
}
